export enum DEVICE_TYPE {
  IOS = 1,
  ANDROID = 2,
  WINDOWS = 3,
}
